import React from 'react';
import { Slide } from "react-awesome-reveal";
import CountUpVisibility from '../components/CountUpVisibility';

const AboutMe: React.FC = () => {

    return <section id='aboutme' className='section' style={{ backgroundColor: "var(--grey3)" }}>
        <h2 className='title2 center'>About me</h2>
        <div className='container row'>
            <Slide triggerOnce>
                <div>
                    <h3 className='aboutTitle'>Hi, I'm <span style={{ fontWeight: 700, borderBottom: '3px solid var(--blue)' }}>Nicola Sagliano</span></h3>
                    <p className='text3' style={{ maxWidth: 700 }}>
                        I am a software developer and analyst and I use keyboard for at least 15 hours a day. My goal is to be able to expand the market for custom keyboards in Italy and my audience is always willing to discover new keyboards and components to choose their next purchase. In my channels I talk a lot about technology and everything that makes life easier for people.
                    </p>
                </div>
            </Slide>
            <div style={{ display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', position: 'relative', top: '-10px' }}>
                <div style={{ display: 'flex', textAlign: 'center', flexDirection: 'column', justifyContent: 'center', position: 'relative' }}>
                    <CountUpVisibility number={215} className='bigNumber' plus={false} />
                    <span className='dot'></span>
                </div>
                <h3 style={{ margin: 0, fontWeight: 600, fontSize: '2rem' }}>Videos produced</h3>
            </div>
        </div>
    </section>
}

export default AboutMe